export default __webpack_public_path__ + "static/media/Group 733.ced7dbec.jpg";